class CartPP extends HTMLElement {
  constructor() {
    super();
	this.onChange();
	this.id = this.getAttribute("id");
  }
  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(
      PUB_SUB_EVENTS.cartUpdate,
      (event) => {
        this.onCartUpdate(event, "cartUpdate");
      }
    );
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  onChange(event) {
    fetch("/cart.js", { method: "GET" })
      .then((response) => response.json())
      .then((cart) => {
        var totalPrice = cart.original_total_price;
        let amountsSteps = 0;
		// Define here Step-borders
        if (totalPrice >= 1) amountsSteps++;
        if (totalPrice >= 3500) amountsSteps++;
        if (totalPrice >= 5000) amountsSteps++;

		const headerDiv = document.querySelector('.' + this.id);
		const circles = headerDiv.querySelectorAll(".pp-circle");
		const progressBar = headerDiv.querySelectorAll(".pp-indicator");

        circles.forEach((circle, index) => {
          circle.classList[index < amountsSteps ? "add" : "remove"](
            "pp-active"
          );
        });

		if (amountsSteps === 0) {
			progressBar.forEach(progressBar => progressBar.style.width = "0%");
		} else {
			progressBar.forEach(progressBar => progressBar.style.width = `${
				((amountsSteps) / (circles.length)) * 100
			  }%`); 
		}
      })
      .catch((error) =>
        console.error("Fehler beim Abrufen des Warenkorbs: " + error)
      );
  }

  onCartUpdate(event, msg) {
    this.onChange(event);
  }
}

customElements.define("cart-pp", CartPP);
